module.exports = __webpack_public_path__ + "static/invitee_bg.ad5fe664.png";